module.exports = __webpack_public_path__ + "img/hr-dry-hairy-tree-00.c6d6c175.png";